export const namespace = (_namespace = 'window.console', _parent: any = window) => {
    if (typeof _namespace === 'string' && _namespace) {
        const parts: string[] = _namespace.split('.');
        for (let i = 0, max = parts.length; i < max; i++) {
            if (!_parent[parts[i]]) _parent[parts[i]] = {};
            _parent = _parent[parts[i]];
        }
    }
    return _parent;
};

export const getUrlParam = (url: string, paramKey: string): string | undefined => {
    const paramVal = new URL(url).searchParams.get(paramKey);
    return paramVal ?? undefined;
};

export const getDefinedSearchParams = (params: Record<string, unknown>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [key, value] of Object.entries(params)) {
        if (isDefined(value)) {
            result[key] = String(value);
        }
    }

    return result;
};

export const stringifyDefinedSearchParams = (params: Record<string, unknown>): string => {
    return new URLSearchParams(getDefinedSearchParams(params)).toString();
};

export const getLocaleInfo = (locale: string = 'ko-kr'): Record<'language' | 'country', string> => {
    // e.g. 'ko-kr', 'ja-jp', 'zh-tw', ...
    const localeValues = locale.split('-');
    return {
        language: localeValues[0],
        country: localeValues[1],
    };
};

export function isDefined<T>(val: T | undefined | null): val is T {
    return !(val === null || typeof val === 'undefined');
}

export async function wait(milliseconds: number): Promise<void> {
    return new Promise((res) => {
        setTimeout(res, milliseconds);
    });
}

export function formatTimeFromUTC(utcString: string): string {
    const date = new Date(utcString + 'Z');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}
/**
 * @category Utils
 * @description 쿠키 세팅
 * @param  {String} name 쿠키이름
 * @param  {String} value 쿠키값
 * @param  {Number} expiredays 만료날짜
 * @example
 * setCookie('topBanner', 'show', 1);
 */
export const setCookie = (name: string = '', value: string = '', expiredays: number = 1, domain: string = ''): void => {
    const now: Date = new Date();
    now.setDate(now.getDate() + expiredays);
    document.cookie = `${name}=${escape(value)}; path=/; domain=${domain};expires=${now.toUTCString()};SameSite=Lax;`;
};

/**
 * @category Utils
 * @description 쿠키 확인
 * @param  {String} name 쿠키이름
 * @returns {String}
 * @example
 * getCookie('topBanner') == 'show' // true : 쿠키가 입력 되어 있는 상태
 */
export const getCookie = (name = ''): string | undefined => {
    const cookies: string = document.cookie;
    if (!cookies.includes(name)) return undefined;
    let cookie: string = cookies.substr(cookies.indexOf(name));
    cookie = cookie.split(';')[0];
    cookie = cookie.substr(cookie.indexOf('=') + 1);
    return cookie;
};

/**
 * @category Utils
 * @description hasClass
 * @example
 * const el = screen.getByTestId('hasClassTest');
 * hasClass(el, 'hasClass')
 */
export const hasClass = (ele: HTMLElement | null, cls: string): boolean => {
    return !!ele?.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
};
